import { legacy_createStore, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer, createMigrate, createTransform } from "redux-persist";
import autoMergeLevel2 from "redux-persist/lib/stateReconciler/autoMergeLevel2";
import rootSaga from "_sagas";
import rootReducer from "_reducers";
import migrations from "_migrations/redux";
import localforage from "localforage";

const getPersistedDispatchCache = (lobState = {}) => ({
  dispatch: {
    all: lobState?.dispatch?.all || {},
    individual: {},
    timers: lobState?.dispatch?.timers || {},
  },
});

const dispatchCacheTransform = createTransform(
  (inboundState, key) => {
    if (key === "telecom" || key === "powerGas") {
      return getPersistedDispatchCache(inboundState);
    }

    return inboundState;
  },
  (outboundState, key) => {
    if (key === "telecom" || key === "powerGas") {
      return getPersistedDispatchCache(outboundState);
    }

    return outboundState;
  },
  { whitelist: ["telecom", "powerGas"] }
);

const persistConfig = {
  key: "root",
  storage: localforage,
  version: 197,
  whitelist: ["auth", "permission", "lob", "settings", "telecom", "powerGas"],
  transforms: [dispatchCacheTransform],
  stateReconciler: autoMergeLevel2,
  migrate: createMigrate(migrations, { debug: false }),
};

const sagaMiddleware = createSagaMiddleware();

const devTools =
  process.env.NODE_ENV === "production"
    ? applyMiddleware(sagaMiddleware)
    : composeWithDevTools(applyMiddleware(sagaMiddleware));

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = legacy_createStore(persistedReducer, devTools);

export let persistor = persistStore(store);

export const purgePersistedState = async () => {
  await persistor.flush();
  await persistor.purge();
};

sagaMiddleware.run(rootSaga);
